import { useSelector } from 'react-redux';

export const getFeatureFlags = (state) => {
  const { features, hasRequestSucceeded: hasLoaded } = state.featureToggle;

  return {
    features,
    loading: !hasLoaded,
    refreshAvailabilityCalendarFlagIsEnabled: hasLoaded
      ? features.get('dining-cx-refresh-availability-calendar')
      : false,
    refreshSearchRevampFlagIsEnabled: hasLoaded
      ? features.get('dining-cx-refresh-search-revamp')
      : false,
    infiniteLoadingFixFlagIsEnabled: hasLoaded
      ? features.get('dining-cx-refresh-ftux-lite')
      : false,
  };
};

export const useFeatureFlags = () => {
  return useSelector(getFeatureFlags);
};
